import { collectForwards } from '@bbkAdminComponents/experiences/offers/collect-forwards';
import { type RestCard } from '@bbkAdminUtils/api-client/rest-experiences-api';

const funnelCollectChainOfCards = (
  cards: RestCard[],
  cardName: string
): string[] => {
  const card = cards.find((c) => c.name === cardName);
  if (!card) return [];
  const cardCtas = collectForwards(card).map((f) => f.value);

  const ctasModals: string[] = cardCtas
    .map((cardCtasModals) => cardCtasModals.modal as string | undefined)
    .filter(Boolean);

  let result = [cardName];
  if (ctasModals.length !== 0) {
    result = [
      ...result,
      ...ctasModals.flatMap((x) => funnelCollectChainOfCards(cards, x)),
    ];
  }
  return result;
};

type ModalName = string;
type CtaId = string;
export const getModalCtaIdMap = (
  cards: RestCard[]
): Record<ModalName, CtaId> => {
  const entries: [ModalName, CtaId][] = cards.flatMap((card) =>
    collectForwards(card)
      .map((c) => c.value)
      .flatMap((cta) => {
        const modal = cta.modal as string | undefined;
        if (!modal || !cta.cta_details_list) return [];
        const ctaIds = cta.cta_details_list
          .filter((ctaDetails) => !!ctaDetails.cta_id)
          .map((ctaDetails) => ctaDetails.cta_id);
        if (!ctaIds.length) return [];
        const chain = funnelCollectChainOfCards(cards, modal);
        return ctaIds.flatMap((ctaId) =>
          chain.map((m) => [m, ctaId] as [ModalName, CtaId])
        );
      })
  );
  return Object.fromEntries(entries);
};
